import React from 'react';

export function useClickEventOnDocument(dep, onClick) {
    React.useEffect(() => {
        const handleClick = (event) => {
            const clickedElement = event.target;
            const isDropdownElement = clickedElement.closest('.dropdown');
            const isFilterPillnElement = clickedElement.closest('.filter-pill');
            if (!isDropdownElement && !clickedElement.classList.contains('filter-pill__show-more') && !isFilterPillnElement) {
                onClick(event);
            }
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [...dep]);
}
